import { memo } from 'react';
import FJTextToImageLeft from '../view/FJTextToImageLeft';
import useLocalStore from '../../../../hooks/useLocalStore';
import { useDispatch, useSelector } from 'react-redux';
import FJActionTextToImage from '../../../../redux/action/FJActionTextToImage';
import { useMemo } from 'react';
import FJTextToImageDataConfig from '../../../../config/dataConfig/FJTextToImageDataConfig';

const FJTextToImageLeftContainer = memo(function FJTextToImageLeftContainer() {
    useLocalStore();

    const dispatch = useDispatch();
    const taskStatus = useSelector(state => state.common.taskStatus);
    const freeNumCreation = useSelector(state => state.common.freeNumCreation);
    const isProjectLoading = useSelector(state => state.common.isProjectLoading);
    const creditNumber = useSelector(state => state.common.creditNumber);

    const curModel = useSelector(state => state.textToImage.curModel);
    const generateNumber = useSelector(state => state.textToImage.generateNumber);

    const useCredit = useMemo(() => {
        const modelUseCredit = FJTextToImageDataConfig.MODELS.find(item => item.value === curModel)?.useCredit;
        const useCredit = modelUseCredit * generateNumber;

        return useCredit;
    }, [curModel, generateNumber]);

    const generate = () => {
        dispatch(FJActionTextToImage.generateAction());
    };

    return (
        <FJTextToImageLeft
            generate={generate}
            taskStatus={taskStatus}
            freeNumCreation={freeNumCreation}
            isProjectLoading={isProjectLoading}
            useCredit={useCredit}
            creditNumber={creditNumber}
        />
    );
});

export default FJTextToImageLeftContainer;
